class Report {
    static init($context = null) {
        function updateDownloadLinks(tab, downloadTarget) {
            var target = $(downloadTarget);
            let url = new URL(target.attr('action'), window.location.origin);
            url.searchParams.set('tab', tab);
            target.attr('action', url.toString());
        }
        function updateTableTh(tab) {
            var targets = $(`#tab-${tab} a`);
            targets.each(function (index, object) {
                var th = $(this);
                let url = new URL(th.attr('href'), window.location.origin);
                url.searchParams.set('tab', tab);
                th.attr('href', url.toString());
            });

            setGetUriParam('tab', tab);
        }
        function setGetUriParam(key,value) {
            if (history.pushState) {
                var params = new URLSearchParams(window.location.search);
                params.set(key, value);
                var newUrl = window.location.origin
                    + window.location.pathname
                    + '?' + params.toString();
                window.history.pushState({path:newUrl},'',newUrl);
            }
        }

        $('body').on('click', 'ul#reportTabs a', function () {
            let tab = $(this).attr('href').replace('#tab-', '');
            var downloadTarget = $(this).parents('ul#reportTabs').attr('data-download-dropdown-target')
            updateDownloadLinks(tab, downloadTarget);
            updateTableTh(tab);
        });

        // page load – paimam active tab
        $(document).ready(function () {
            let activeTab = $('ul#reportTabs a.active').attr('href')?.replace('#tab-', '');
            if (activeTab) {
                var downloadTarget = $('ul#reportTabs').attr('data-download-dropdown-target')
                updateDownloadLinks(activeTab, downloadTarget);
                updateTableTh(activeTab);
            }
        });
        //region Jeigu URL yra "tab" parametras
        const params = new URLSearchParams(window.location.search);
        const tab = params.get('tab');
        if (tab) {
            const selector = `ul#reportTabs a[href="#tab-${tab}"]`;
            const $tab = $(selector);
            if ($tab.length) {
                const tabInstance = new bootstrap.Tab($tab[0]);
                tabInstance.show();
            }
        }
        //endregion Jeigu URL yra "tab" parametras

        $('body').on('input', 'input.select2-search__field', function(event) {
            if (event.target.value.length >= 255) {
                $(event.target).val($(event.target).val().substr(0, 255));
            }
        });
    }

    //constructor() {
    //    console.log('constructor');
    //}
}

if (typeof module === "object" && typeof module.exports === "object"){

    Report.init()
    //node modules support
    module.exports = Report;
}else{
    $(function(){
        Report.init()
    });
}
